import { Card } from 'antd';
import { PackageForm } from '../../components/Package/PackageForm';
import { TitleBreadcrumbs } from '../../uiComponents/TitleBreadcrumbs';

export const Package = () => {
  return (
    <Card bordered={true} title={<TitleBreadcrumbs />} className="gx-card">
      <PackageForm path={"/dashboard/paquetes"}/>
    </Card>
  );
};
